<template>
<div>
	<div  :class="ccss" style="z-index: 100000;"></div>
	<div class="modal fade" ref="modalExcluir" style="z-index: 100000;">
		<div class="iphone-x-top"></div>
		<div class="modal-dialog" style="z-index: 100000;" :style="{'max-width':  '40%' }">

			<div class="modal-content" style="padding:1em">
				<div class="row text-center">
					<div class="col-12">
						<div v-html="text"></div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12">
						<button type="button" @click="clickFechar" class="btn float-left btn-outline-secondary">
							<fa-icon icon="times" /> Fechar
						</button>

						<button type="button" class="btn float-right btn-danger" ref="btnExcluir">
							<fa-icon :icon="['far', 'trash-alt']"  /> Cancelar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import  {Modal}  from '../../library/boostrap-native-v4'
export default {

    data () {
        return {
			text:"",
			modal:  null,
			ccss: null,
        }
    },

    methods: {

		clickFechar(){
			this.modal.hide()
		},

		show(text, data){

			return new Promise((resolve, reject) => {

				if (!this.$parent) {
					this.$mount()
					document.body.appendChild(this.$el)
				}

				this.text = text

				this.modal = new Modal(this.$refs.modalExcluir, {
					backdrop: 'static',
					show: true
				})

				this.ccss = 'modal-backdrop show'

				this.modal.show()


				this.$refs.modalExcluir.addEventListener('hide.bs.modal', (event) => {
					this.ccss = null
					this.$emit('modal-hide', this.action)
				}, false);

				this.$refs.btnExcluir.addEventListener("click", () =>{
					this.modal.hide()
					resolve(data)
				})
			})
		},
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modal-cancelar/main.vue